import {
	generalSagas,
	userSagas,
	businessSagas,
	notificationSagas,
	messageSagas,
	packageSagas,
	categorySagas,
	fileSagas,
	servicesSaga,
	couponSaga,
	locationSagas,
	commentSagas,
	ticketSagas,
	financialSagas,
	questionSagas,
	reportsSagas,
	walletPaymentSagas,
} from 'Ducks';

const rootSagas = [
	...generalSagas,
	...userSagas,
	...businessSagas,
	...notificationSagas,
	...messageSagas,
	...packageSagas,
	...categorySagas,
	...fileSagas,
	...servicesSaga,
	...couponSaga,
	...locationSagas,
	...commentSagas,
	...ticketSagas,
	...financialSagas,
	...questionSagas,
	...reportsSagas,
	...walletPaymentSagas,
];

export default rootSagas;
